import React, { useState, useRef, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Slider,
  IconButton,
  Grid,
} from "@mui/material";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import RotateRightIcon from "@mui/icons-material/RotateRight";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import CropIcon from "@mui/icons-material/Crop";
import { SimpleInputTextWithKeyboard } from "../composant/clavie/InputClientUPloadfiles";
import ColorSelector from "./color/ColorSelector";

const bgThumbStyle = (url) => ({
  width: 70,
  height: 70,
  borderRadius: 8,
  backgroundImage: `url('${url}')`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  cursor: "pointer",
  marginBottom: 8,
  transition: "border 0.2s, box-shadow 0.2s",
});

const getRotatedImage = (image, rotation) => {
  try {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    const angle = (rotation * Math.PI) / 180;
    const width = image.naturalWidth;
    const height = image.naturalHeight;

    const sin = Math.abs(Math.sin(angle));
    const cos = Math.abs(Math.cos(angle));
    const newWidth = width * cos + height * sin;
    const newHeight = width * sin + height * cos;

    canvas.width = newWidth;
    canvas.height = newHeight;

    ctx.translate(newWidth / 2, newHeight / 2);
    ctx.rotate(angle);
    ctx.drawImage(image, -width / 2, -height / 2);

    // Return the base64 image safely
    return canvas.toDataURL("image/jpeg");
  } catch (error) {
    console.warn("⚠️ Rotation failed due to CORS restrictions:", error);
    // Fallback: return original image if rotation fails
    return image.src;
  }
};

export default function EditImagePopup({
  open,
  onClose,
  src,
  background,
  setBackground,
  backgrounds,
  demonsion,
  onSubmit,
  setText,
  text = null,
  color = null,
  setColor,
  documentType = null,
  type,
  idEvent = null,
}) {
  const [brightness, setBrightness] = useState(1);
  const [rotation, setRotation] = useState(0);
  const [displayCrop, setDisplayCrop] = useState(false);
  const [crop, setCrop] = useState({
    unit: "%",
    height: 100,
    aspect: demonsion?.typeCroperW / demonsion?.typeCroperH,
  });
  const [rotatedSrc, setRotatedSrc] = useState(src);
  const imgRef = useRef(null);
  console.log("rotation :", rotation);
  useEffect(() => {
    setRotatedSrc(src);
  }, [src]);
  function Close() {
    setRotation(0);
    setDisplayCrop(false);
    setCrop({
      unit: "%",
      height: 100,
    });
    //  setRotatedSrc(null);
    onClose();
  }
  const handleRotation = async (angle) => {
    const newRotation = rotation + angle;
    setRotation(newRotation);

    if (imgRef.current) {
      const rotated = getRotatedImage(imgRef.current, angle);
      console.log("rotated image:", rotated);
      setRotatedSrc(rotated);
    }
  };
  console.log("color || documentType", color || documentType);
  return (
    <Dialog open={open} onClose={Close} maxWidth="md" fullWidth>
      <DialogContent>
        <div style={{ textAlign: "center" }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <div style={{ display: "flex", justifyContent: "center" }}>
                {displayCrop ? (
                  <ReactCrop
                    crop={crop}
                    onChange={(newCrop) => setCrop(newCrop)}
                    aspect={demonsion?.typeCroperW / demonsion?.typeCroperH}
                  >
                    <img
                      ref={imgRef}
                      crossOrigin="anonymous"
                      src={rotatedSrc}
                      alt="Editable"
                      style={{
                        height: "400px",
                        filter: `brightness(${brightness})`,
                      }}
                    />
                  </ReactCrop>
                ) : (
                  <>
                    {background ? (
                      <div
                        style={{
                          position: "relative",
                          margin: "0 auto",
                          borderRadius: "12px",
                          overflow: "hidden",
                          background: `url(${background}) center/cover no-repeat`,
                        }}
                      >
                        <img
                          ref={imgRef}
                          crossOrigin="anonymous"
                          src={rotatedSrc}
                          alt="Editable"
                          style={{
                            height: "400px",
                            filter: `brightness(${brightness})`,
                          }}
                        />
                      </div>
                    ) : (
                      <img
                        ref={imgRef}
                        crossOrigin="anonymous"
                        src={rotatedSrc}
                        alt="Editable"
                        style={{
                          height: "400px",
                          filter: `brightness(${brightness})`,
                        }}
                      />
                    )}
                  </>
                )}
              </div>
            </Grid>

            <Grid item xs={12}>
              <Slider
                value={brightness}
                onChange={(e, newValue) => setBrightness(newValue)}
                step={0.1}
                min={0.5}
                max={2}
                sx={{ width: "50%" }}
              />
            </Grid>

            <Grid item xs={12}>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <IconButton size="large" onClick={() => handleRotation(-90)}>
                  <RotateLeftIcon />
                </IconButton>
                <IconButton size="large" onClick={() => handleRotation(90)}>
                  <RotateRightIcon />
                </IconButton>
                <IconButton
                  size="large"
                  onClick={() => setDisplayCrop(!displayCrop)}
                >
                  <CropIcon />
                </IconButton>
              </div>
            </Grid>

            {(color || documentType) && (
              <>
                <Grid item xs={12}>
                  document type: {documentType}
                </Grid>
                <Grid item xs={12}>
                  <ColorSelector index={0} color={color} setColor={setColor} />
                </Grid>
              </>
            )}

            {text !== null && (
              <Grid item xs={12}>
                <SimpleInputTextWithKeyboard
                  text={text}
                  setText={setText}
                  type={type}
                  idEvent={idEvent}
                />
              </Grid>
            )}

            <Grid item xs={12}>
              {backgrounds && (
                <Grid container spacing={2}>
                  {backgrounds.map((bg) => (
                    <Grid item xs={2} key={bg.id}>
                      <div
                        style={bgThumbStyle(bg.Url)}
                        onClick={() => setBackground(bg.Url)}
                        title={`Background ${bg.id}`}
                      />
                    </Grid>
                  ))}
                </Grid>
              )}
            </Grid>
          </Grid>
        </div>
      </DialogContent>

      <DialogActions>
        <Button onClick={Close}>Cancel</Button>
        <Button
          onClick={() =>
            onSubmit(crop, displayCrop, brightness, rotation, rotatedSrc)
          }
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
